<template>
    <DxTreeList ref="treeListRef" :data-source="dsAgenti" key-expr="Id" parent-id-expr="ParinteID" :root-value="null"
        :show-borders="false" :row-alternation-enabled="true" :column-auto-width="true" :auto-expand-all="true"
        :hover-state-enabled="true" :word-wrap-enabled="true" @init-new-row="onInitNewRow">
        <DxToolbar>
            <DxItem name="addRowButton" />
            <DxItem name="searchPanel" />
        </DxToolbar>

        <DxEditing :allow-adding="true" :allow-deleting="true" :allow-updating="true" mode="popup" :texts="{
            confirmDeleteMessage: 'Sigur doriți să ștergeți această înregistrare?',
            confirmDeleteTitle: 'Confirmare Ștergere'
        }">

            <DxTreePopup :closeOnOutsideClick="false" :showCloseButton="false" width="400px" height="580px"
                :show-title="true" title-template="editTitle">
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="saveButtonOptions" />
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="dangerButtonOptions" />
            </DxTreePopup>
            <DxForm :col-count="1">
                <DxItem data-field="Nume" :editor-options="{ height: 50 }">
                    <DxRequiredRule message="Numele este obligatoriu!" />
                </DxItem>
                <DxItem data-field="Cod" :editor-options="{ height: 50 }" />
                <DxItem data-field="Descriere" :editor-options="{ height: 50 }" />
                <DxItem data-field="Email" :editor-options="{ height: 50 }" />
                <DxItem data-field="Tel" :editor-options="{ height: 50 }">
                    <DxPatternRule pattern="^[0-9]+$" message="Numărul de telefon trebuie să conțină doar cifre!" />
                </DxItem>
                <DxItem data-field="NotifPartenerInsert" editor-type="dxCheckBox" css-class="centered-checkbox"
                    :label="{ text: 'Notificare Agent' }"
                    :editor-options="{ value: false, enableThreeStateBehavior: false }" />
            </DxForm>
        </DxEditing>
        <template #editTitle>
            <div
                style="background-color:#ff2c21; font-size:15px; color:white; font-weight:bold; padding:10px 0 10px 20px; width:100%;">
                Editare Agent
            </div>
        </template>

        <DxRowDragging :on-drag-change="onDragChange" :on-reorder="onReorder" :allow-drop-inside-item="true"
            :allow-reordering="true" />
        <DxSearchPanel :visible="true" :width="250" />
        <DxHeaderFilter :visible="true" />

        <DxColumn type="buttons">
            <DxTreeButton name="add" hint="Adaugă sub agent" />
            <DxTreeButton name="edit" />
            <DxTreeButton name="delete" />
        </DxColumn>
        <DxColumn data-field="Cod" caption="Cod" :visible="false" />
        <DxColumn data-field="Nume" caption="Nume" cell-template="numeTemplate" />
        <template #numeTemplate="{ data: cellInfo }">
            <div v-if="cellInfo">
                <span v-if="cellInfo.row.node && cellInfo.row.node.hasChildren">🧑‍🧒‍🧒 </span>
                <span v-else>👤 </span>

                <span>{{ cellInfo.text }}</span>
            </div>
        </template>
        <DxColumn data-field="Descriere" caption="Descriere" :visible="false" />
        <DxColumn data-field="ProcentGeneralClienti" caption="Procent General Clienti" :visible="false" />
        <DxColumn data-field="ProcentGeneralRamuri" caption="Procent General Ramuri" :visible="false" />
        <DxColumn data-field="Nivel" caption="Nivel" />
        <DxColumn data-field="Email" caption="Email" />
        <DxColumn data-field="Tel" caption="Telefon" />
        <DxColumn data-field="NotifPartenerInsert" caption="Notificare Partener Insert" data-type="boolean"
            :visible="false" />
        <DxColumn data-field="ParinteID" :visible="false" />
    </DxTreeList>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import {
    DxTreeList,
    DxColumn,
    DxEditing,
    DxPopup as DxTreePopup,
    DxForm,
    DxItem,
    DxSearchPanel,
    DxHeaderFilter,
    DxRequiredRule,
    DxButton as DxTreeButton,
    DxPatternRule,
    DxToolbar,
    DxRowDragging
} from 'devextreme-vue/tree-list';
import { DxEmptyItem } from 'devextreme-vue/form';
import { DxPopup } from 'devextreme-vue/popup';
import { DxButton } from 'devextreme-vue/button';
import { DxToolbarItem } from 'devextreme-vue/popup';
import DataSource from 'devextreme/data/data_source';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import { DxCol } from 'devextreme-vue/cjs/responsive-box';
import { target } from 'devexpress-reporting/scopes/reporting-designer-controls-metadata';

export default defineComponent({
    components: {
        DxColumn,
        DxEditing,
        DxRequiredRule,
        DxItem,
        DxButton,
        DxSearchPanel,
        DxForm,
        DxTreePopup,
        DxTreeList,
        DxTreeButton,
        DxHeaderFilter,
        DxToolbarItem,
        DxEmptyItem,
        DxPatternRule,
        DxPopup,
        DxToolbar,
        DxRowDragging
    },
    data() {
        return {
            dsAgenti: null as any,
            addButtonOptions: {
                type: "success",
                text: "Salvează",
                stylingMode: "contained",
                onClick: () => {
                    this.onSaveAdd()
                }
            },
            saveButtonOptions: {
                type: "success",
                text: "Salvează",
                stylingMode: "contained",
                onClick: () => {
                    this.onSaveEdit()
                }
            },
            closeButtonOptions: {
                type: "danger",
                text: "Închide",
                stylingMode: "contained",
                onClick: () => {
                    this.onCloseAdd()
                }
            },
            dangerButtonOptions: {
                type: "danger",
                text: "Închide",
                stylingMode: "contained",
                onClick: () => {
                    this.closeEditPopup()
                }
            },
            numberBoxOptions: {
                min: 0,
                step: 1,
                showSpinButtons: true,
                showClearButton: true,
                height: 50,
                readOnly: true
            },
            decimalBoxOptions: {
                min: 0,
                step: 0.1,
                showSpinButtons: true,
                showClearButton: true,
                height: 50,
                format: {
                    type: "fixedPoint",
                    precision: 2
                }
            },
        }
    },
    methods: {
        loadData() {
            this.dsAgenti = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + `COM_Agenti`,
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    },
                },
            })
        },
        async onReorder(e: any) {
            const visibleRows = e.component.getVisibleRows()
            const sourceData = e.itemData
            const targetRow = visibleRows[e.toIndex]
            let newParentID = null

            console.log(visibleRows)

            if (targetRow && targetRow.node) {
                const targetNode = targetRow.node

                if (e.dropInsideItem) {
                    newParentID = targetNode.key
                } else {
                    newParentID = targetNode.data?.ParinteID ?? null
                }
            } else {
                newParentID = null
            }

            if (sourceData.ParinteID === newParentID) return

            try {
                await this.dsAgenti.store().update(sourceData.Id, { ParinteID: newParentID })
                this.loadData()
                notify("Ierarhia a fost actualizată", "success", 2000)
            } catch (error) {
                notify("Eroare la salvarea ierarhiei", "error", 2000)
                console.error(error)
            }
        },
        onDragChange(e: any) {
            const visibleRows = e.component.getVisibleRows()
            const sourceNode = e.component.getNodeByKey(e.itemData.Id)
            let targetNode = visibleRows[e.toIndex].node

            while (targetNode && targetNode.parent) {
                if (targetNode.key === sourceNode.key) {
                    e.cancel = true
                    break
                }
                targetNode = targetNode.parent
            }
        },
        closeEditPopup() {
            const treeList = (this.$refs.treeListRef as any).instance
            treeList.cancelEditData()
        },
        async onSaveEdit() {
            const treeList = (this.$refs.treeListRef as any).instance
            try {
                await treeList.saveEditData()
            } catch (error) {
                console.error("Eroare la salvare:", error)
            }
        },
        onInitNewRow(e: any) {
            if (e.data.ParinteID) {
                const parentNode = e.component.getNodeByKey(e.data.ParinteID)

                if (parentNode && parentNode.data) {
                    e.data.Nivel = (parentNode.data.Nivel || 0) + 1
                }
            } else {
                e.data.ParinteID = null
                e.data.Nivel = 0
            }
        },
        spyData(cellInfo: any) {
            console.log("Node Info:", cellInfo.node);
            console.log("Full Cell Data:", cellInfo);
            return ""; // Returnăm string gol ca să nu afișeze nimic pe ecran
        }
    },
    mounted() {
        this.loadData()
    }
})  
</script>
<style>
.dx-treelist-empty-space {
    width: 35px !important;
}

.centered-checkbox .dx-field-item-content {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>